
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.47 3.91V1.696S4.076.588 8.028.588c3.95 0 7.557 1.108 7.557 1.108V3.91l-5.398 7.784v7.718s-1.317-.1-2.43-.653c-1.111-.554-1.889-1.562-1.889-1.562v-5.503L.47 3.91z","fill":"#7A838B"}})])
          )
        }
      }
    